export const TEXT = 'Text'
export const SELECT = 'Select'
export const DATE = 'Date'
export const PICKER = 'Picker'